module.exports = __webpack_public_path__ + "static/media/rural_lands-bg.81870c8b.jpg";